/* import __COLOCATED_TEMPLATE__ from './user-material-status.hbs.js'; */
import { buildTask as _buildTask } from "ember-concurrency/async-arrow-runtime";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { TrackedAsyncData } from 'ember-async-data';
import { cached, tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import { restartableTask, timeout } from 'ember-concurrency';
let UserMaterialStatusComponent = (_class = class UserMaterialStatusComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "store", _descriptor, this);
    _initializerDefineProperty(this, "currentUser", _descriptor2, this);
    _initializerDefineProperty(this, "iliosConfig", _descriptor3, this);
    _initializerDefineProperty(this, "tmpStatus", _descriptor4, this);
    _defineProperty(this, "userModel", new TrackedAsyncData(this.currentUser.getModel()));
    _defineProperty(this, "setStatus", _buildTask(() => ({
      context: this,
      generator: function* (statusValue) {
        this.tmpStatus = statusValue;
        let materialStatus = this.materialStatus;
        if (!materialStatus) {
          const user = yield this.currentUser.getModel();
          const sessionLearningMaterial = yield this.store.findRecord('session-learning-material', this.args.learningMaterial.sessionLearningMaterial);
          materialStatus = this.store.createRecord('user-session-material-status', {
            user,
            material: sessionLearningMaterial,
            status: 0
          });
        }
        materialStatus.set('status', statusValue);
        yield timeout(500);
        yield materialStatus.save();
        this.tmpStatus = null;
      }
    }), null, "setStatus", "restartable"));
  }
  get sessionMaterialStatusesData() {
    return new TrackedAsyncData(this.user?.sessionMaterialStatuses);
  }
  get isEnabledData() {
    return new TrackedAsyncData(this.iliosConfig.itemFromConfig('materialStatusEnabled'));
  }
  get user() {
    return this.userModel.isResolved ? this.userModel.value : null;
  }
  get sessionMaterialStatuses() {
    return this.sessionMaterialStatusesData.isResolved ? this.sessionMaterialStatusesData.value : null;
  }
  get isEnabled() {
    return this.isEnabledData.isResolved ? this.isEnabledData.value : null;
  }
  get isStatusLoaded() {
    return Boolean(this.sessionMaterialStatuses);
  }
  get isSessionLearningMaterial() {
    return Boolean(this.args.learningMaterial.sessionLearningMaterial);
  }
  get materialStatus() {
    return this.sessionMaterialStatuses?.find(status => {
      const materialId = Number(status.belongsTo('material').id());
      const targetId = Number(this.args.learningMaterial.sessionLearningMaterial);
      return materialId === targetId;
    });
  }
  get status() {
    if (this.tmpStatus) {
      return this.tmpStatus;
    }
    return this.materialStatus?.status || 0;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "currentUser", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "iliosConfig", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "tmpStatus", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "sessionMaterialStatusesData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "sessionMaterialStatusesData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isEnabledData", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "isEnabledData"), _class.prototype), _class);
export { UserMaterialStatusComponent as default };